/**
 * Copyright (C) 2021 - 2026 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { DevLoginService } from '../../services/dev-login/dev-login.service';

@Component({
	selector: 'dev-login',
	templateUrl: './dev-login.component.html',
	styleUrls: ['./dev-login.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class DevLoginComponent {
	public devLoginForm: UntypedFormGroup;
	public isLoading = false;

	constructor(
		private readonly devLoginService: DevLoginService,
		private readonly fb: UntypedFormBuilder,
	) {
		this.createForm();
	}

	private createForm() {
		this.devLoginForm = this.fb.group({
			username: ['', Validators.required],
			password: ['', Validators.required],
		});
	}

	public onSubmit() {
		const devLoginModel = this.devLoginForm.value;
		this.isLoading = true;
		this.devLoginService
			.login(devLoginModel.username, devLoginModel.password)
			.pipe(
				finalize(() => {
					this.isLoading = false;
				}),
			)
			.subscribe();
	}
}
